
<q-page
  class="ws-min-height-1000 window-width row justify-center items-center"
>
  <div class="col row justify-center items-center q-pa-md full-width">
    <div class="container">
      <div class="row">
        <div class="col">
          <h5 class="title">
            <b>404</b> {{ $t('page404.title') }}
          </h5>
          <p>{{ $t('page404.message') }}</p>
          <ws-button
            :type="WsButtonEnum.Type.PRIMARY"
            :size="WsButtonEnum.Size.LARGE"
            :element="WsButtonEnum.Element.A"
            :label="$t('page404.action_btn')"
            href="/"
          />
        </div>
      </div>
    </div>
  </div>
</q-page>
